import React from "react";

// Hand-drawn marks (pure SVG) for the "made by a person" look.
export const Scribble = ({ color = "var(--ggm-signal-cyan)", className = "", style }) => (
  <svg aria-hidden viewBox="0 0 300 24" preserveAspectRatio="none" className={`ggm-draw ${className}`} style={style}>
    <path d="M3 15 C 50 6, 95 19, 140 11 S 230 4, 297 13" fill="none" stroke={color} strokeWidth="5" strokeLinecap="round" />
    <path d="M30 20 C 90 14, 170 21, 260 16" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" opacity="0.6" />
  </svg>
);

export const HandCircle = ({ color = "var(--ggm-signal-cyan)", className = "", style }) => (
  <svg aria-hidden viewBox="0 0 200 90" preserveAspectRatio="none" className={`ggm-draw pointer-events-none ${className}`} style={style}>
    <path d="M150 10 C 190 18, 196 62, 140 78 C 90 90, 18 84, 8 52 C 0 22, 60 6, 118 8 C 150 9, 168 16, 176 22" fill="none" stroke={color} strokeWidth="3" strokeLinecap="round" />
  </svg>
);

export const HandArrow = ({ color = "var(--ggm-signal-cyan)", className = "", style }) => (
  <svg aria-hidden viewBox="0 0 120 60" className={`ggm-draw ${className}`} style={style}>
    <path d="M6 10 C 30 46, 70 52, 104 34" fill="none" stroke={color} strokeWidth="3" strokeLinecap="round" />
    <path d="M90 24 L 106 33 L 92 46" fill="none" stroke={color} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const HandCheck = ({ color = "var(--ggm-orbit-blue)", size = 26 }) => (
  <svg aria-hidden viewBox="0 0 32 32" width={size} height={size} className="shrink-0">
    <path d="M4 5 L 27 4 L 28 27 L 5 28 Z" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" opacity="0.55" />
    <path d="M8 16 L 14 23 L 30 2" fill="none" stroke={color} strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const Tape = ({ className = "", style }) => <span aria-hidden className={`ggm-tape ${className}`} style={style} />;

export const HandNote = ({ children, className = "", tilt = -2, testId }) => (
  <span className={`ggm-hand inline-block ${className}`} style={{ transform: `rotate(${tilt}deg)` }} data-testid={testId}>
    {children}
  </span>
);
